// MODAL
const modalWrap = document.querySelectorAll('.modal');

const modalShow = () => {
    modalWrap.forEach(item => {
        document.body.classList.add('is-open-modal');
        item.classList.add('is-active');
    });
}

const modalHide = () => {
    modalWrap.forEach(item => {
        document.body.classList.remove('is-open-modal');
        item.classList.remove('is-active');
    });
}

const modal = () => {
    modalWrap.forEach(item => {
        const openButton = item.querySelector('.modal-open-button');
        if (openButton) {
            openButton.addEventListener('click', () => {
                if (document.body.classList.contains('is-open-modal')) {
                    document.body.classList.remove('is-open-modal');
                    item.classList.remove('is-active');
                } else {
                    document.body.classList.add('is-open-modal');
                    item.classList.add('is-active');
                }
            });
        }
        const closeButton = item.querySelector('.modal-close-button');
        if (closeButton) {
            closeButton.addEventListener("click", modalHide);
        }

        const timeout = item.getAttribute('data-timeout');
        if (timeout) {
            setTimeout(modalShow, timeout);
        }
    });
}

export {modal};
